import { render, staticRenderFns } from "./NormPerDayAmount.vue?vue&type=template&id=d4f3a948&scoped=true"
import script from "./NormPerDayAmount.vue?vue&type=script&lang=js"
export * from "./NormPerDayAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f3a948",
  null
  
)

export default component.exports